import parse from 'html-react-parser';

interface TestimonialProps {
  classes?: string;
  headshot?: string;
  quote: string;
  name: string;
  school: string;
}

const Testimonal: React.FC<TestimonialProps> = ({
  classes,
  headshot,
  quote,
  name,
  school,
}) => {
  return (
    <div className={`testimonial ${classes}`}>
      <div className="testimonial_content">
        <p>&quot;{parse(quote)}&quot;</p>
      </div>
      <div className="testimonial_container">
        {headshot && (
          <div className="testimonial_container_headshot">
            <img src={headshot} alt={name} />
          </div>
        )}
        <div className="sub">
          <div className="sub_name">{parse(name)}</div>
          <div className="sub_school">{parse(school)}</div>
        </div>
      </div>
    </div>
  );
};

export default Testimonal;
